import { useLocation, useNavigate } from 'react-router-dom';

import { Typography } from '@mui/material';

import { useBalanceStore } from '@/entities/balance';

import CroppedPercentImg from '@/shared/assets/images/cropped-percent.png';
import { PATHS } from '@/shared/constants/routes/paths';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { SBackgroundImage, SButton, SContainer, SText, STextContainer } from './styled';

type UpgradeCardProps = {
  onClose: () => void;
};

export const UpgradeCard = ({ onClose }: UpgradeCardProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { hasArchivedSubscription } = useBalanceStore();

  const handleButtonClick = () => {
    if (hasArchivedSubscription) {
      MixpanelEvents.minutesModalViewPlansClick();
    }

    if (!hasArchivedSubscription) {
      MixpanelEvents.payLessMinutesButton();
    }

    navigate(`/${PATHS.pricing}`, { state: { path: location.pathname } });
    onClose();
  };

  return (
    <SContainer>
      <SBackgroundImage component="img" src={CroppedPercentImg} />

      <STextContainer>
        <Typography variant="body-2-md">
          {hasArchivedSubscription ? 'We just launched new pricing!' : 'Pay only $1.5 per minute!'}
        </Typography>

        <SText color="grey.500" variant="caption-1">
          {hasArchivedSubscription ? (
            'Check out our new pricing with flexible bundled minutes and new features!'
          ) : (
            <>
              Upgrade your plan and pay less
              <br />
              for additional minutes
            </>
          )}
        </SText>
      </STextContainer>

      <SButton data-testid="buy-minutes-modal-view-plans" variant="secondary" onClick={handleButtonClick}>
        {hasArchivedSubscription ? 'View plans' : 'Pay less'}
      </SButton>
    </SContainer>
  );
};
